import { ITranslatable } from "@/models/vimy.models";

export type ValidatorFn = (context: IValidatorContext) => void;

export class ValidatorManager implements IValidatorContext {
    private validators: ValidatorFn[] = [];
    private _errors: IValidationError[] = [];

    get errors() {
        return this._errors;
    }

    constructor(validators: ValidatorFn[]) {
        this.validators = validators;
    }

    get isValid() {
        return this._errors.length === 0;
    }

    getErrorSummary(key: string, lang: string) {
        return this._errors
            .filter(t => t.key == key)
            .map(t => (t.message as any)[lang])
            .join('\n');
    }

    getErrorsMessages(lang: string) {
        // @ts-ignore
        return this._errors.map(t => t.message[lang]);
    }

    getSummary(lang: string) {
        return this.getErrorsMessages(lang)
            .join('\n');
    }

    addError(key: string, message: ITranslatable<string>): void {
        this._errors.push({
            key: key,
            message: message
        });
    }

    validate(): boolean {
        this._errors = [];

        for (const validator of this.validators) {
            validator(this);
        }
        return this.isValid;
    }
}

export interface IValidatorContext {
    addError(key: string, message: ITranslatable<string>): void;
}

export interface IValidationError {
    key: string;
    message: ITranslatable<string>;
}